<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'预测列表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					 <div class="h-formBox w-formBox">
						<el-form-item label="选择月">
							<el-date-picker
								:clearable="true"
								v-model="formInline.month"
								type="month"
								value-format="yyyy-MM"
								placeholder="--月份--">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addPrice">
							    新增预测
							</el-button>
						</el-form-item>
					</div>
				</el-form>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
							max-height="510"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                label="区域"
								width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLRegion"  :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                :show-overflow-tooltip="true"
                                label="客户名称">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.cuname}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="month"
								width="200"
                                :show-overflow-tooltip="true"
                                label="时间(月份)">
                        </el-table-column>
                        <el-table-column
                                prop="totalSales"
								width="150"
                                :show-overflow-tooltip="true"
                                label="总额(元)">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.totalSales}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="conclude"
								width="150"
                                :show-overflow-tooltip="true"
                                label="指标保障度">
<!--                            <template scope="scope">-->
<!--                                <span>{{scope.row.conclude}}</span>-->
<!--                                <img v-if="parseInt(scope.row.conclude)<70" src="../../../assets/images/jiantou.png"/>-->
<!--                            </template>-->
<!--                            <template scope="scope">-->
<!--                                <div v-if="parseInt(scope.row.conclude)<70" style="display:flex;justify-content: center;">-->
<!--                                    <span style="margin-left: 10px;margin-right:10px;">{{scope.row.conclude}}</span>-->
<!--                                    <img src="../../../assets/images/jiantou.png"/>-->
<!--                                </div>-->
<!--                                <div v-else style="display:flex;justify-content: center;">-->
<!--                                    <span>{{scope.row.conclude}}</span>-->
<!--                                </div>-->
<!--                            </template>-->
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
								width="150"
                                :show-overflow-tooltip="true"
                                label="预测状态">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="income"
								width="150"
                                :show-overflow-tooltip="true"
                                label="收入(元)">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.income}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column label="操作"
                                         width="230">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
									<el-button
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="selectTable(scope.row.id)">
									    查看
									</el-button>
									<el-button
									        v-if="(scope.row.forecastStatus == 1 || scope.row.forecastStatus == 4) && _user.usercode == scope.row.cucode"
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="showTable(scope.row.id,scope.row.cucode)">
									    编辑
									</el-button>
									<el-button
									        v-if="scope.row.forecastStatus == 3 && _user.usercode == scope.row.cucode && (now == scope.row.month || mo == scope.row.month)"
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="showRevise(scope.row.id,scope.row.month,scope.row.cucode)">
									    修改
									</el-button>
									<el-button
									        size="small" class="h-tableLink h-btn" v-if="scope.row.instId"
									        @click="genzongLiuch(scope.row)">
									    跟踪
									</el-button>
								</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<div class="h-tableB h-mrt30" style="margin-left:20px">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;">批量导出</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="daoru">批量导入</el-button>
                        </div>
                    </div>-->
                    <!--<el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
                        <div class="h-dialogImg">
                            <div style="display:flex;align-items:center;">
                                <img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
                                <div>
                                        <p class="piliang1">批量导入</p>
                                        <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
                                </div>
                            </div>
                            <div class="piliangBox">
                                <div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
                                                                style="width: 40px;height: 39px;"></div>
                                <div class="imgs">批量导入模版文件.xlsx</div>
                                <div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
                            </div>
                            <div style="width:100%;">
                                <el-upload
                                            action="https://jsonplaceholder.typicode.com/posts/"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="handleRemove"
                                            style="width:100%;">
                                        <div style="width:100%;">+ 上传文件</div>
                                </el-upload>
                            </div>
                            <div style="display:flex;justify-content:center;margin-top:30px;">
                                <el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
                                        取消
                                </el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ2" style="margin-left:40px;"
                                                @click="dialogFormVisible2 = false">提交
                                </el-button>
                            </div>
                        </div>
                    </el-dialog>-->
                    <div class="h-tableB h-mrt30">
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="formInline" @query="selectData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                dialogFormVisible2:false,
                showArea: false,
                showAn: false,
                userCode: '',
                showhistory:false,
                instid: '',
                now: '',
                mon: '',
                mo: '',
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                d: {
                    month: '',
                    cucode: ''
                },
                formInline: {
                    month:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                multipleSelection: [],
                tableData: [],
            }
        },
        mounted() {
        },
        created() {
            var today = new Date();
            var year = today.getFullYear();
            var m = today.getMonth()+1;
            var month = today.getMonth()+2;
            if (m < 10) {
                this.mo = year+"-0"+m;
            } else {
                this.mo = year+"-"+m;
            }
            if (month == 13) {
                year = year + 1;
                month = 1;
            }
            if (month < 10) {
                this.now = year+"-0"+month;
            } else {
                this.now = year+"-"+month;
            }
            this.query();
        },
        activated(){
            this.handleFilter();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
            genzongLiuch(v){
                this.instid = v.instId;
                this.showhistory = true;
            },
            // 导入弹窗按钮
            daoru() {
                this.dialogFormVisible2 = true;
            },
                // 重置按钮
            resetData(){
                // this.formInline.month = this.getyyyyMMdd();
                this.formInline.month = '';
                this.formInline.pageSize = 10;
                this.query();
            },
            getyyyyMMdd(){
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1,].join('-');
            },
            query(){
                ss.jianjie.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            selectData() {
                ss.jianjie.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.mon = this.formInline.month;
                })
            },
            handleFilter() {
				this.formInline.pageNo = 1;
				ss.jianjie.page(this.formInline).then(rd => {
					this.formInline.total = rd.total;
					this.tableData = rd.records;
					this.mon = this.formInline.month;
				})
            },
            addPrice() {
                var today = new Date();
                var year = today.getFullYear();
                var month = today.getMonth()+2;
                if (month == 13) {
                    year = year + 1;
                    month = 1;
                }
                this.userCode = this._user.usercode;
                this.d.month = this.now;
                this.d.cucode = this._user.usercode;
                ss.jianjie.selectDa(this.d).then(rd => {
                    if (rd.forecastStatus == 2 || rd.forecastStatus == 3) {
                        this.$msg.msg(year+"年"+month+"月的预测信息已提报");
                    }else{
                        this.$router.push({path:"/yuce/pingshen",query:{month: this.now,userCode: this.userCode}});
                    }
                })
            },
            selectTable(id){
                // console.log(id)
                this.$router.push({path:"/yuce/xiangqing",query:{id: id}})
            },
            showTable(id,cucode){
                this.$router.push({name: "/yuce/pingshen", query: {bid: id, userCode: cucode}})
            },
            showRevise(id,month,cucode) {
                this.$router.push({name: "/yuce/yuceRevise", query: {bid: id, mon: month, userCode: cucode}})
            }
        }
    }
</script>
<style>
    /* .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    } */
    /* .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;

        margin-bottom: 20px;
    }
    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;

    } */
</style>
